import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/resolving': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M281.2 278.2l-197.9 57.2-28.6-98.6 188.2-54.1c52.7-15.3 65-8.1 71.1 12.8l11.2 39.3c5.6 19.9 2 30.1-44 43.4zM248.5 8c137 0 248.5 111.4 247.5 247.7 0 136.9-111.5 248.3-248.5 248.3-46 0-89.5-12.7-126.3-34.7l-23-80.2 286.8 37.3 48.1-13.3-9.7-34.2-220.4-27.1 92.6-26.6c30.2-8.7 42-15.8 61.4-33.2 24.5-23 31.7-45.5 23.5-73.6l-10.7-37.8c-8.7-30.2-25.1-49.1-61.4-55.2-25.1-3.5-44.5-2-79.3 8.2l-221.9 63.9c26-108.8 124.2-189.5 241.3-189.5zM38.3 388.6c-24-38.4-38.3-83.3-38.3-131.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/resolving.js
// module id = 995
// module chunks = 0